import React from 'react';
import { Modal, Button, ListGroup, Row, Col, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import { getCurrencySymbol } from '../../common_components/choices';

const ProductOfferDetailsModal = ({ showModal, setShowModal, selectedOffer }) => {
    // Get the normal price and date_time from the selectedOffer object
    const normalPriceInfo = selectedOffer?.prices?.length ? selectedOffer.prices[0] : null;
    const normalPrice = normalPriceInfo ? `${normalPriceInfo.price} ${getCurrencySymbol(normalPriceInfo.price_currency)}` : null;
    const normalPriceDateTime = normalPriceInfo && normalPriceInfo.date_time ? moment(normalPriceInfo.date_time).format('DD-MMM-YYYY') : 'Date not available';

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Offers for {selectedOffer?.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {selectedOffer?.offers && (
                    <ListGroup>
                        {selectedOffer.offers.map((offer) => (
                            <ListGroup.Item key={offer.id}>
                                <Row>
                                    <Col md={8}>
                                        <h5>{offer.name || 'No name available'}</h5>
                                    </Col>
                                    <Col md={4} className="text-end">
                                        <Badge bg={offer.status === 'ACTIVE' ? 'success' : 'secondary'}>{offer.status}</Badge>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <p><strong>Valid:</strong> {moment(offer.start_date).format('DD-MMM-YYYY')} to {moment(offer.end_date).format('DD-MMM-YYYY')}</p>
                                        <p>
                                            <strong>Price:</strong>
                                            {normalPrice && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip id="tooltip-price">Last updated: {normalPriceDateTime}</Tooltip>}
                                                >
                                                    <span style={{ textDecoration: 'line-through', marginRight: '5px', paddingLeft: '5px' }}>{normalPrice}</span>
                                                </OverlayTrigger>
                                            )}
                                            {offer.offer_price_details.length ? `${offer.offer_price_details[0].price} ${getCurrencySymbol(offer.offer_price_details[0].currency)}` : 'N/A'}
                                        </p>
                                    </Col>
                                    <Col md={6}>
                                        <p><strong>Stores:</strong></p>
                                        {offer.stores.length > 0 ? (
                                            <ul>
                                                {offer.stores.map((store) => (
                                                    <li key={store.id}>{store.name}</li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p>No stores available for this offer.</p>
                                        )}
                                    </Col>
                                </Row>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ProductOfferDetailsModal;
